import { supabase } from '@/lib/supabase';

export const MAX_SECONDARY_CATEGORIES = 5;

export async function fetchMySecondaryCategories(profileId: string): Promise<{ id: number; name: string }[]> {
  const { data, error } = await supabase
    .from('profile_secondary_categories')
    .select('profession_category_id, profession_categories(id, name)')
    .eq('profile_id', profileId);
  if (error) throw error;
  return ((data ?? []) as any[])
    .map((row) => row.profession_categories as { id: number; name: string } | null)
    .filter((c): c is { id: number; name: string } => !!c);
}

export async function addSecondaryCategory(profileId: string, categoryId: number): Promise<void> {
  const { error } = await supabase
    .from('profile_secondary_categories')
    .insert({ profile_id: profileId, profession_category_id: categoryId });
  if (error) throw error;
}

export async function removeSecondaryCategory(profileId: string, categoryId: number): Promise<void> {
  const { error } = await supabase
    .from('profile_secondary_categories')
    .delete()
    .eq('profile_id', profileId)
    .eq('profession_category_id', categoryId);
  if (error) throw error;
}
